// 微信-微信-电影演出票小程序
import Url from '../utils/url';
var goingLogin = false;
export default {
  appName: 'wxapp_wallet',
  useKNB: false,
  sellChannel: 7,
  theme: 'maoyan',
  ajaxUrl: '//wx.maoyan.com/maoyansh/myshow/ajax',
  ajaxBetaUrl: '//m.51ping.com/myshow/ajax',
  getUserInfo: function getUserInfo() {
    return {
      token: Url.getQuery('_token') || Url.getHashQuery('_token'),
      openId: Url.getQuery('_openId') || Url.getHashQuery('_openId'),
      userId: Url.getQuery('_userId') || Url.getHashQuery('_userId')
    };
  },
  getLocation: function getLocation() {
    return {
      lat: Url.getQuery('_lat') || Url.getHashQuery('_lat'),
      lng: Url.getQuery('_lng') || Url.getHashQuery('_lng')
    };
  },
  getCity: function getCity() {
    return {
      cityId: Url.getQuery('_cityId') || Url.getHashQuery('_cityId'),
      cityName: Url.getQuery('_cityName') || Url.getHashQuery('_cityName')
    };
  },
  login: function login() {
    if (!goingLogin && window.wx) {
      // 防止多次调用
      goingLogin = true;
      setTimeout(function () {
        goingLogin = false;
      }, 3000); // end

      window.wx.miniProgram.navigateTo({
        url: "/pages/login/index"
      });
    }
  }
};